import { render, staticRenderFns } from "./BulkImport.vue?vue&type=template&id=1ae19354&"
import script from "./BulkImport.vue?vue&type=script&lang=js&"
export * from "./BulkImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports